import axios from '@/plugins/axios'
import format from 'date-fns/format'

export default {
  namespaced: true,

  state: {
    loading: false,
    date_range: [],
    active_track_campaigns: [],
    vc_spent: [],
    vc_views: [],
    vc_available: [],
    yt_video_no: [],
    sv_nr_tracks: [],
    vidcents_total: [],
    user_wallets: [],
    track_campaign: [],
    label_campaign: [],
    label: [],
    LineChartSett: {
      width: 'auto',
      height: 500,
      is3D: true,
      colors: ['#085178', '#e80021', '#1b9e77', '#2c67a5'],
      curveType: 'none',
      isStacked: 'relative',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 13
        },
        color: '#FF0000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '5%',
        top: '5%',
        width: '100%',
        height: '70%'
      }
    },
    PieChartSett: {
      width: 'auto',
      height: 500,
      is3D: false,
      pieSliceText: 'value',
      colors: ['#ffa400', '#292347'],
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%',
        height: '70%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      }
    }
  },

  mutations: {
    setActiveCampaings(state, payload) {
      state.active_track_campaigns = payload
    },
    setVCSpent(state, payload) {
      state.vc_spent = payload
    },
    setVCViews(state, payload) {
      state.vc_views = payload
    },
    setVCAvailable(state, payload) {
      state.vc_available = payload
    },
    setYoutubeVideo(state, payload) {
      state.yt_video_no = payload
    },
    setNRTracks(state, payload) {
      state.sv_nr_tracks = payload
    },
    setTotal(state, payload) {
      state.vidcents_total = payload
    },
    setUserWallets(state, payload) {
      state.user_wallets = payload
    },
    setTrackCampaign(state, payload) {
      state.track_campaign = payload
    },
    setLabelCampaign(state, payload) {
      state.label_campaign = payload
    },
    setLabel(state, payload) {
      state.label = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload.start, payload.end]
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readCollective({ commit }, type) {
      commit('setLoading', true)
      axios.api
        .get(`vc/report/collective/${type}`)
        .then(r => {
          r.data.data.map(s => {
            if (s[0] !== 'Created') {
              s[0] = format(new Date(s[0]), 'dd MMM yyyy')
            }
          })
          switch (type) {
            case 'active_track_campaigns':
              commit('setActiveCampaings', r.data.data)
              break
            case 'vc_spent':
              commit('setVCSpent', r.data.data)
              break
            case 'vc_views':
              commit('setVCViews', r.data.data)
              break
            case 'vc_available':
              commit('setVCAvailable', r.data.data)
              break
            case 'yt_video_no':
              commit('setYoutubeVideo', r.data.data)
              break
            case 'sv_nr_tracks':
              commit('setNRTracks', r.data.data)
              break
          }
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTrackCampaign({ commit }, data) {
      commit('setLoading', true)
      axios.api
        .get(`vc/report/track-campaign/${data.id}/vc_spent`)
        .then(r => {
          // console.log(r.data.data, 'Track Campaign');
          commit('setTrackCampaign', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readLabelCampaign({ commit }, data) {
      commit('setLoading', true)
      axios.api
        .get(`vc/label/${data.id}/campaign/get`)
        .then(r => {
          commit('setLabelCampaign', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readLabel({ commit }, data) {
      commit('setLoading', true)
      axios.api
        .get(`vc/label/${data.id}`)
        .then(r => {
          commit('setLabel', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTotal({ commit }) {
      commit('setLoading', true)
      axios.api
        .get('vc/report/get')
        .then(r => {
          let data = r.data.data.filter(
            (d, i, s) => i === s.findIndex(t => t.sv_track_id === d.sv_track_id)
          )
          commit('setTotal', data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readUserWallets({ commit }) {
      commit('setLoading', true)
      axios.api
        .get('vc/report/user/wallets')
        .then(r => {
          commit('setUserWallets', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  },

  getters: {
    vc_total_overview: state => {
      let totalVC = 0
      let totalNonVC = 0
      let today = format(new Date(), 'dd MMM yyyy')
      state.active_track_campaigns.map(a => {
        if (a[1] !== 'Active Track Campaigns' && a[0] === today) {
          totalVC = a[1]
        }
      })
      state.sv_nr_tracks.map(s => {
        if (s[1] !== 'Sv Nr Tracks' && s[0] === today) {
          totalNonVC = s[1]
        }
      })
      let result = [
        ['Tracks with VidCents', 'Tracks without VidCents'],
        ['Tracks with VidCents', totalVC],
        ['Tracks without VidCents', totalNonVC - totalVC]
      ]
      return result
    },

    vc_tracks_campaign: state => {
      let totalSpent = 0
      let today = format(new Date(), 'yyyy-MM-dd')
      state.track_campaign.map(a => {
        if (a[1] !== 'Vc Spent' && a[0] === today) {
          totalSpent = a[1]
        }
      })
      // temporary solution for displaying pie charts data
      let result = [
        ['Spent', 'Available'],
        ['Spent', totalSpent],
        ['Available', 100 - totalSpent]
      ]
      return result
    },

    vc_label: state => {
      let result = []
      state.label.filter(s => {
        result = s.vc_campaign
      })
      return result
    }
  }
}
